const BUCKET_URL = process.env.REACT_APP_BUCKET_URL;

export const getFilePath = (
  imageName?: string,
  fallback?: string,
  userType?: string
) => {
  // userType 은 카리아카 호출부 호환용으로만 받는다(카리페이는 모두 기본 프로필 이미지).
  if (!imageName || imageName === "") {
    return fallback || "/assets/image/default_profile.png";
  }

  // 로컬 경로인 경우 그대로 반환
  if (imageName.startsWith("/assets/")) {
    return imageName;
  }

  // full URL(CloudFront, S3 presigned 등)은 그대로 사용
  if (imageName.startsWith("http://") || imageName.startsWith("https://")) {
    return imageName;
  }

  return `${BUCKET_URL}/${imageName}`;
};
